<template>
    <div class="form">
        <section class="form-section">
            <div class="form-row">
                <div class="form-row__col">
                    <alert type="info">
                        {{ trans('emails.note.template') }}
                    </alert>
                </div>
            </div>
            <div class="form-row">
                <div class="form-row__col form-row__col--one-half">
                    <label class="label" for="standard_layout">
                        {{ trans('emails.label.standard_layout') }}
                    </label>
                    <select
                        name="standard_layout"
                        class="form-select"
                        v-model="fields.standardLayout"
                        id="standard_layout"
                    >
                        <option disabled>{{
                            trans('clients.label.select')
                        }}</option>
                        <option :value="true">{{
                            trans('buttons.yes')
                        }}</option>
                        <option :value="false">{{
                            trans('buttons.no')
                        }}</option>
                    </select>
                </div>
            </div>
            <div class="form-row">
                <div class="form-row__col">
                    <form-text-area
                        name="text"
                        :value="fields.text"
                        v-model="fields.text"
                        rows="10"
                    >
                    </form-text-area>
                </div>
            </div>
        </section>

        <div class="page-control">
            <div class="page-control__element">
                <button type="submit" class="btn btn--big btn--primary">
                    {{ trans('buttons.submit') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: '',
        },
        standardLayout: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            fields: {
                text: this.old('text', this.text),
                standardLayout: this.old(
                    'standard_layout',
                    this.standardLayout
                ),
            },
        };
    },
};
</script>
